module.exports = require('./$.hide');


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/core-js/library/modules/$.redefine.js
 ** module id = 18
 ** module chunks = 2
 **/